import React from 'react';
import MenuItems from './menu_items'

class MenuMobile extends React.Component{
    render() {
        return (
            <div className="menu_mobile_wrap">
                <MenuItems/>
            </div>
        )
    }
}

export default MenuMobile;
